import Main from "../Game/Main.js";
import PageCommon from "./PageCommon.js";

export default class PageDefault extends PageCommon {
	constructor() {
		super();
	}

	init() {
		super.init();
		var main = new Main();
		main.init();
	}


}


